import React from 'react';
import './SportsMeditationPage.css';
import logo from "../assets/bg-remover-logo.png"
import MeditationImage from "../assets/meditationImage.jpeg"
import MeditatonVidio from "../assets/VID-20251107-WA0113.mp4"

function SportsMeditationPage() {
  return (
    <div className="sports-meditation-page">
      {/* Hero Section */}
      <section className="meditation-hero">
        <div className="container">
          <div className="hero-content">
            <h1 className="hero-title">Sports Meditation</h1>
            <p className="hero-subtitle">Enhance your athletic performance through mindful training</p>
          </div>
        </div>
      </section>
      {/* Sports Meditation Insight Section */}
      <section className="insight-section">
        <div className="container">
          <div className="insight-content">
            <div className="insight-text">
              <h2 className="section-title">The Essence of Sports Meditation</h2>
              <p className="section-description">
                Sports meditation is not just about sitting still — it’s a powerful practice that helps athletes master their minds to reach peak performance. Through focused breathing, mental visualization, and mindfulness techniques, players develop inner calm, sharper focus, and stronger emotional control. In the fast-paced world of sports, staying mentally centred can be the key to consistent success. Sports meditation trains athletes to handle pressure, silence distractions, and stay confident no matter the situation. It bridges the gap between physical strength and mental clarity, allowing every athlete to perform with balance, precision, and purpose — both on and off the field.
                Incorporating just 10 minutes of meditation into your daily routine can make a huge difference in your performance, focus, and overall mindset. The more you train your mind, the sharper and calmer your game becomes.
              </p>
              {/* <p className="section-description">
                Incorporating just 10 minutes of meditation into your daily routine can make a huge difference in your performance,
                focus, and overall mindset. The more you train your mind, the sharper and calmer your game becomes.
              </p> */}
            </div>

            <div className="insight-media">
              <img
                src={MeditationImage}
                alt="Athlete meditating before training"
                className="insight-image"
              />
              <div className="video-container">
                <video
                  src={MeditatonVidio}
                  className="meditation-video"
                  autoPlay
                  muted
                  loop
                  controls
                  playsInline
                ></video>
              </div>

            </div>
          </div>
        </div>
      </section>

      {/* How it Works Section */}
      <section className="how-it-works-section">
        <div className="container">
          <h2 className="section-title">How it Works</h2>
          <p className="section-description">
            Sports meditation works by training the mind to be present and focused. It can take various forms, but often involves:
          </p>

          <div className="meditation-methods">
            <div className="method-card">
              <div className="method-icon">
                <img src="https://images.unsplash.com/photo-1506905925346-21bda4d32df4?w=100&h=100&fit=crop&crop=center" alt="Mindful Breathing" />
              </div>
              <h3 className="method-title">Mindful Breathing</h3>
              <p className="method-description">
                Focusing on the breath to anchor the mind in the present moment. This helps to quiet racing thoughts and achieve a state of calm.
              </p>
            </div>

            <div className="method-card">
              <div className="method-icon">
                <img src="https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?w=100&h=100&fit=crop&crop=center" alt="Visualization" />
              </div>
              <h3 className="method-title">Visualization</h3>
              <p className="method-description">
                Mentally rehearsing a performance or skill. By visualizing success, athletes can train their nervous system to react as if the event were real, building confidence and reinforcing muscle memory.
              </p>
            </div>

            <div className="method-card">
              <div className="method-icon">
                <img src="https://images.unsplash.com/photo-1559757148-5c350d0d3c56?w=100&h=100&fit=crop&crop=center" alt="Body Scan" />
              </div>
              <h3 className="method-title">Body Scan</h3>
              <p className="method-description">
                Bringing attention to different parts of the body to increase awareness of physical sensations, tension, and discomfort. This can help prevent injuries and improve recovery.
              </p>
            </div>

            <div className="method-card">
              <div className="method-icon">
                <img src="https://images.unsplash.com/photo-1544717297-fa95b6ee9643?w=100&h=100&fit=crop&crop=center" alt="Focused Attention" />
              </div>
              <h3 className="method-title">Focused Attention</h3>
              <p className="method-description">
                Directing attention to a single object or task, such as the feel of a ball in your hand or the rhythm of your strides. This builds mental resilience and helps athletes stay focused under pressure.
              </p>
            </div>
          </div>
        </div>
      </section>


      {/* Benefits Section */}
      <section className="benefits-section">
        <div className="container">
          <h2 className="section-title">Key Benefits for Athletes</h2>
          <p className="section-description">
            Integrating sports meditation into a training routine can provide numerous benefits, including:
          </p>

          <div className="benefits-grid">
            <div className="benefit-item">
              <div className="benefit-icon">
                <img src="https://images.unsplash.com/photo-1551698618-1dfe5d97d256?w=100&h=100&fit=crop&crop=center" alt="Enhanced Focus" />
              </div>
              <h3 className="benefit-title">Enhanced Focus and Concentration</h3>
              <p className="benefit-description">
                Sports Meditation helps athletes tune out distractions and concentrate on task-relevant cues, which is crucial for peak performance.
              </p>
            </div>

            <div className="benefit-item">
              <div className="benefit-icon">
                <img src="https://images.unsplash.com/photo-1506905925346-21bda4d32df4?w=100&h=100&fit=crop&crop=center" alt="Stress Reduction" />
              </div>
              <h3 className="benefit-title">Stress and Anxiety Reduction</h3>
              <p className="benefit-description">
                By lowering cortisol (the stress hormone) levels and promoting a sense of calm, sports meditation helps athletes manage the pressure of competition.
              </p>
            </div>

            <div className="benefit-item">
              <div className="benefit-icon">
                <img src="https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?w=100&h=100&fit=crop&crop=center" alt="Recovery" />
              </div>
              <h3 className="benefit-title">Improved Recovery and Injury Prevention</h3>
              <p className="benefit-description">
                Sports Meditation helps the body relax, which can speed up physical recovery times and even strengthen the immune system. Increased body awareness can also help athletes identify areas of tension and prevent injuries.
              </p>
            </div>

            <div className="benefit-item">
              <div className="benefit-icon">
                <img src="https://images.unsplash.com/photo-1559757148-5c350d0d3c56?w=100&h=100&fit=crop&crop=center" alt="Resilience" />
              </div>
              <h3 className="benefit-title">Increased Emotional Resilience</h3>
              <p className="benefit-description">
                Athletes learn to observe their thoughts and emotions without judgment, allowing them to bounce back from setbacks and failures more effectively.
              </p>
            </div>

            <div className="benefit-item">
              <div className="benefit-icon">
                <img src="https://images.unsplash.com/photo-1544717297-fa95b6ee9643?w=100&h=100&fit=crop&crop=center" alt="Endurance" />
              </div>
              <h3 className="benefit-title">Enhanced Endurance and Pain Tolerance</h3>
              <p className="benefit-description">
                By training the mind, athletes can push through challenging moments of fatigue and discomfort, as meditation helps to change the perception of effort.
              </p>
            </div>

            <div className="benefit-item">
              <div className="benefit-icon">
                <img src="https://images.unsplash.com/photo-1506905925346-21bda4d32df4?w=100&h=100&fit=crop&crop=center" alt="Better Sleep" />
              </div>
              <h3 className="benefit-title">Better Sleep</h3>
              <p className="benefit-description">
                Sports Meditation can improve the quality and duration of sleep, which is vital for physical and mental recovery.
              </p>
            </div>

            <div className="benefit-item">
              <div className="benefit-icon">
                <img src="https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?w=100&h=100&fit=crop&crop=center" alt="Mind-Body Connection" />
              </div>
              <h3 className="benefit-title">Improved Mind-Body Connection</h3>
              <p className="benefit-description">
              It helps athletes become more attuned to their bodies, leading to a better understanding of their physical limits, strengths, and weaknesses. 
              </p>
            </div>
          </div>
        </div>
      </section>



      {/* Call to Action Section */}
      <section className="cta-section">
        <div className="container">
          <div className="cta-content">
            <h2 className="cta-title">Ready to Enhance Your Performance?</h2>
            <p className="cta-description">
            Start your journey with sports meditation and unlock your full athletic potential.
              <br></br>
              <br></br>
              Sports Meditation combines mental focus with physical discipline, helping athletes enhance concentration, reduce stress, and perform with greater confidence. It’s the key to mastering both the game and the mind — building strength, clarity, and balance from within.
            </p>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer id="contact" className="footer">
        <div className="footer-background"></div>
        <div className="container">
          <div className="footer-content">
            <div className="footer-column">
              <h3 className="footer-title">About Us</h3>
              <p className="footer-text">
                We are committed to excellence in sports training and community building.
                Our comprehensive programs help athletes develop both physically and mentally.
              </p>
            </div>
            <div className="footer-column">
              <h3 className="footer-title">Latest Posts</h3>
              <div className="footer-post">
                <div className="post-date">
                  <span className="day">15</span>
                  <span className="month">Fri</span>
                </div>
                <div className="post-content">
                  <h4 className="post-title">New Training Program Launched</h4>
                  <p className="post-excerpt">Advanced coaching techniques for professional athletes</p>
                </div>
              </div>
              <div className="footer-post">
                <div className="post-date">
                  <span className="day">04</span>
                  <span className="month">Fri</span>
                </div>
                <div className="post-content">
                  <h4 className="post-title">Championship Results Announced</h4>
                  <p className="post-excerpt">Outstanding performances in the latest tournament</p>
                </div>
              </div>
              <a href="#" className="view-more">View More...</a>
            </div>
            <div className="footer-column">
              <h3 className="footer-title">Quick Links</h3>
              <ul className="footer-links">
                <li><a href="#" className="footer-link active">HOME</a></li>
                <li><a href="#" className="footer-link">ABOUT OUR WEBSITE</a></li>
                <li><a href="#" className="footer-link">SHOP</a></li>
                <li><a href="#" className="footer-link">GALLERY</a></li>
                <li><a href="#" className="footer-link">CONTACT</a></li>
              </ul>
            </div>
            <div className="footer-column">
              <h3 className="footer-title">Contact Details</h3>
              <div className="contact-info">
                <div className="contact-item">📍 36/B Lane no.5 dharm park shyam nagar-2 Rajasthan/Jaipur - 302019</div>
                <div className="contact-item">📞 +91-9414050348</div>
                <div className="contact-item">✉️ askmesportsalliance@gmail.com</div>
                <div className="contact-item">🌐 www.askmesportsalliance.com</div>
                <div className="contact-item">🕐 7AM - 8PM</div>
              </div>
            </div>
          </div>
          <div className="footer-logo">
            <img src={logo} alt="Sports Infrastructure Solutions Logo" className="footer-logo-icon" />
            <span className="footer-logo-text">ASKME SPORTS ALLIANCE</span>
          </div>
          <div className="footer-social">
            <span className="social-icon">f</span>
            <span className="social-icon">t</span>
            <span className="social-icon">in</span>
            <span className="social-icon">G+</span>
          </div>
          <div className="footer-copyright">
            Copyright © 2023 ASK ME SPORTS ALLIANCE. Building Future, Shaping Champions.
          </div>
        </div>
      </footer>
    </div>
  );
}

export default SportsMeditationPage;
